/** @format */
'use client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SortingArrows from '@molecules/Table/SortingArrows';
import { SortableColumn } from '@molecules/Table/Table';
import React from 'react';
import { TableHeaderProps } from 'react-table';
import styles from './Table.module.css';

interface ThProps<T extends object> {
  onSort?(sort: Record<string, 'asc' | 'desc'>): void;
  sort: Record<string, 'asc' | 'desc'>;
  columnHeaderProps: TableHeaderProps;
  column: SortableColumn<T>;
  sortColumn(column: SortableColumn<T>): void;
}

function SortableTh<T extends object>(props: ThProps<T>) {
  const { key, ...columnHeaderProps } = props.columnHeaderProps;
  if (!!props.onSort) {
    return (
      <th
        className={styles.th}
        {...columnHeaderProps}
        key={key}
        onClick={() => {
          props.sortColumn(props.column);
        }}
      >
        <span style={{ gap: '12px' }}>
          {
            // Render the header
            props.column.render('Header')
          }
          {props.column.canSort && (
            <span>
              <SortingArrows sortId={props.column.sortId} sort={props.sort} />
            </span>
          )}
        </span>
      </th>
    );
  }

  return (
    <th className={styles.th} key={key} {...columnHeaderProps}>
      <span style={{ gap: '12px' }}>
        {
          // Render the header
          props.column.render('Header')
        }
        {props.column.canSort && (
          <span>
            {props.column.isSorted ? (
              props.column.isSortedDesc ? (
                <FontAwesomeIcon className={styles.sortIcon} icon={['fad', 'sort-down']} />
              ) : (
                <FontAwesomeIcon className={styles.sortIcon} icon={['fad', 'sort-up']} />
              )
            ) : (
              <FontAwesomeIcon className={styles.sortIcon} style={{ color: '#969696' }} icon={['far', 'sort']} />
            )}
          </span>
        )}
      </span>
    </th>
  );
}

export default SortableTh;
